import React from 'react';
import backgroundImg1 from "../../Assets/Images/backgroundImg1.png";
import './Alert.scss';


function Alert() {
    return (
        <div id='alert'>
            <img className="backgroundImg1" src={backgroundImg1} alt="camera" />
            <div className='alertText'>
                <p className='alertButton' href='/'>ALERT</p><a className='learnMore' href='https://whop.com/frugal-szn-1'>Join now for instant access.</a>
            </div>
        </div>
    )
}

export default Alert